import React, { useRef, useEffect } from "react";
import { TextArea } from '../ModalContent.style';
import { formatMessage } from '../../../../../locale';
const MAX_LENGTH = 560;

const Description = ({description, setDescription}: any) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const adjustHeight = () => {
    if (textAreaRef.current) {
      // Reset height to auto to properly calculate the new height
      textAreaRef.current.style.height = "auto";
      // Set the height to match the scroll height
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(e.target.value);
    adjustHeight();
  };

  // Adjust height on initial render and when description changes
  useEffect(() => {
    adjustHeight();
    // Additional window resize listener to handle layout changes
    window.addEventListener('resize', adjustHeight);
    return () => window.removeEventListener('resize', adjustHeight);
  }, [description]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <TextArea
        ref={textAreaRef}
        value={description}
        onChange={handleInput}
        placeholder={formatMessage({ id: 'taskType.descriptionLabel', defaultMessage: 'Enter a activity type description' })}
        maxLength={MAX_LENGTH}
        style={{ 
          width: "100%", 
          overflow: "visible", // Changed from "visible" to prevent scrollbar
          resize: "none",     // Prevent manual resizing since we're auto-sizing
          minHeight: "40px"   // Set a minimum height
        }}
      />
      <span
        style={{
          position: "absolute",
          right: 5,
          bottom: 15,
          fontSize: 10,
          color: "lightgrey",
          background: "white",
          pointerEvents: "none"
        }}
      >
        {description.length}/{MAX_LENGTH}
      </span>
    </div>
  );
};

export default Description;